import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep, findIndex } from "lodash-es";
import store from "store";
// import { appMessage } from '../utils/formatting'
import { updateObject } from "utils/helper";
// import { urlMenu } from "utils/urlMenu";

const initialState = {
  config: {
    apiToken: null,
    expiredToken: null,
    locale: "id-ID",
    selectedCompany: null,
    endpoint: "",
    isMobileView: false,
    isTabView: false,
    isMobileMenuOpen: false,
    isMenuCollapsed: store.get("app.menu.isMenuCollapsed") || false,
  },
  app: {
    user: {},
    loadedInit: false,
    loadedInitTicket: false,
    menu: [],
    loadingInit: false,
    loadingInitTicket: false,
    companies: [],
    translation: {},
    option: {},
    phone_numbers: [],
    phone_number_statuses: {},
    agents: [],
    error_codes: [],
    templates: [],
    selectedPhoneNumber: null,
    tags: [],
    salutations: store.get("app.salutations") || [],
    ticket: {},
    announcement: "",
    crm_iso_setting: null, // [crm-iso] field terpisah agar tak ketimpa setApp inits
  },
};

const slice = createSlice({
  name: "module",
  initialState,
  reducers: {
    setConfig: (state, { payload }) =>
      updateObject(state, { config: { ...state.config, ...payload } }),
    setApp: (state, { payload }) =>
      updateObject(state, {
        app: {
          ...state.app,
          ...payload,
          // loadedInit: !isEmpty(payload),
        },
      }),
    resetData: (state) =>
      updateObject(state, {
        config: {
          ...initialState.config,
          apiToken: state.config.apiToken,
          expiredToken: state.config.expiredToken,
          isMobileView: state.config.isMobileView,
          isTabView: state.config.isTabView,
        },
        app: initialState.app,
      }),
    logout: (state) =>
      updateObject(state, {
        config: initialState.config,
        app: initialState.app,
      }),
    setUser: (state, { payload }) =>
      updateObject(state, {
        app: { ...state.app, user: { ...state.app.user, ...payload } },
      }),
    setLoadingInit: (state, { payload }) =>
      updateObject(state, {
        app: {
          ...state.app,
          loadingInit: payload,
        },
      }),
    setLoadingInitTicket: (state, { payload }) =>
      updateObject(state, {
        app: {
          ...state.app,
          loadingInitTicket: payload,
        },
      }),
    setLoadedInit: (state, { payload }) =>
      updateObject(state, {
        app: {
          ...state.app,
          loadedInit: payload,
        },
      }),
    setLoadedInitTicket: (state, { payload }) =>
      updateObject(state, {
        app: {
          ...state.app,
          loadedInitTicket: payload,
        },
      }),
    setOption: (state, { payload }) =>
      updateObject(state, {
        app: {
          ...state.app,
          option: { ...state.app.option, ...payload },
        },
      }),
    // [crm-iso] simpan crm_iso_setting di field terpisah (lihat CrmIsoSetting/TEARDOWN.md)
    setCrmIsoSetting: (state, { payload }) =>
      updateObject(state, {
        app: { ...state.app, crm_iso_setting: payload },
      }),
    setSelectedPhoneNumber: (state, { payload }) =>
      updateObject(state, {
        app: {
          ...state.app,
          selectedPhoneNumber: payload,
        },
      }),
    setTags: (state, { payload }) =>
      updateObject(state, {
        app: { ...state.app, tags: payload },
      }),
    addTag: (state, { payload }) =>
      updateObject(state, {
        app: { ...state.app, tags: [...state.app.tags, payload] },
      }),
    updateTag: (state, { payload: { id, ...restPayload } }) => {
      const tags = cloneDeep(state.app.tags);
      const index = findIndex(tags, { id });
      if (index !== -1) {
        tags[index] = { ...tags[index], ...restPayload };
      }
      return updateObject(state, {
        app: { ...state.app, tags },
      });
    },
    deleteTag: (state, { payload }) => {
      const tags = cloneDeep(state.app.tags);
      const index = findIndex(tags, { id: payload });
      if (index !== -1) {
        tags.splice(index, 1);
      }
      return updateObject(state, {
        app: { ...state.app, tags },
      });
    },
    updatePhoneNumber: (state, { payload }) => {
      const phoneNumbers = cloneDeep(state.app.phone_numbers);

      const phoneNumberIndex = phoneNumbers.findIndex(
        (phoneNumber) => phoneNumber.id === payload.id
      );

      if (phoneNumberIndex >= 0) {
        phoneNumbers[phoneNumberIndex] = payload;
      }

      return updateObject(state, {
        app: {
          ...state.app,
          phone_numbers: phoneNumbers,
        },
      });
    },
    setOptionSettings: (state, { payload }) => {
      return updateObject(state, {
        app: {
          ...state.app,
          option: {
            ...state.app.option,
            settings: { ...state.app.option.settings, ...payload },
          },
        },
      });
    },
    updateTabsFilter: (state, { payload }) => {
      return updateObject(state, {
        app: {
          ...state.app,
          ticket: {
            ...state.app.ticket,
            filters: payload,
          },
        },
      });
    },
    updateInboxTicketing: (state, { payload }) => {
      return updateObject(state, {
        app: {
          ...state.app,
          ticket: {
            ...state.app.ticket,
            inboxes: payload,
          },
        },
      });
    },
  },
});

export const {
  setConfig,
  logout,
  setApp,
  setUser,
  resetData,
  setLoadedInit,
  setLoadingInit,
  setOption,
  setCrmIsoSetting, // [crm-iso]
  setSelectedPhoneNumber,
  addTag,
  updateTag,
  deleteTag,
  setTags,
  updatePhoneNumber,
  setOptionSettings,
  setLoadedInitTicket,
  setLoadingInitTicket,
  updateTabsFilter,
  updateInboxTicketing,
} = slice.actions;

export default slice;
